import { Tabs, TabsList, TabsTrigger } from "@/components/ui";
import { ClipboardList, HelpCircle } from "lucide-react";
import { Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useSetPageTitle } from "../../context/PageTitleContext";
import QuizRoute from "./pages/QuizDetail/quiz";
import QuestionsRoute from "./questions";
import QuizzesRoute from "./quizzes";

const QuizzesLayout = () => {
  useSetPageTitle("I miei test", "Test e domande");
  const location = useLocation();
  const navigate = useNavigate();
  const isQuestions = location.pathname.includes("/questions");

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
      <Tabs
        value={isQuestions ? "questions" : "quizzes"}
        onValueChange={(v) => navigate(v === "questions" ? "/quizzes/questions" : "/quizzes")}
        className="mb-6"
      >
        <TabsList className="h-auto gap-2 bg-transparent p-0">
          <TabsTrigger
            value="quizzes"
            className="gap-2 rounded-full border border-[var(--color-mockup-border)] bg-surface px-5 py-2.5 text-xs font-bold shadow-sm data-[state=active]:border-transparent data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-md"
          >
            <ClipboardList className="h-4 w-4" />
            Test
          </TabsTrigger>
          <TabsTrigger
            value="questions"
            className="gap-2 rounded-full border border-[var(--color-mockup-border)] bg-surface px-5 py-2.5 text-xs font-bold shadow-sm data-[state=active]:border-transparent data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow-md"
          >
            <HelpCircle className="h-4 w-4" />
            Domande
          </TabsTrigger>
        </TabsList>
      </Tabs>
      <Outlet />
    </div>
  );
};

const QuizzesRoutes = () => {
  return (
    <Routes>
      <Route path="questions" element={<QuizzesLayout />}>
        <Route index element={<QuestionsRoute />} />
      </Route>
      <Route path=":id" element={<QuizRoute />} />
      <Route element={<QuizzesLayout />}>
        <Route index element={<QuizzesRoute />} />
      </Route>
    </Routes>
  );
};

export default QuizzesRoutes;
